import { smartSearchType } from "@shared/components/smart-search-form/smart-search-form.constant";
import { Utilities } from "../utils/utilities";
import { TranslateService } from "@ngx-translate/core";

export class LongRunningTaskData {
  constructor(
    public taskId: string,
    public longRunningCallback: boolean,
    public dataUrl: string
  ) { }
}

export interface ActionTask {
  taskId: string;
  taskName: string;
  status: string;
  backgroundFinished: boolean;
  dataUrl: string;
  taskData: any;
  response: any;
  error: WebApiResponseBase; // HttpErrorResponse
}


export interface WebApiFileResponse {
  error: any;
  text: string;
  httpResponseStatus: number;
  fileName: string;
}

export interface WebApiResponseBase {
  totalCount: number;

  // For error response
  // friendlyMessage: string;
  // errorMessage: string;
  errorMessage_Translation_Id: string;
  errorCode: string;
  friendlyMessage_Translation_Id: string;
  // http response status code
  httpResponseStatus: number;
}

export const GetErrorMessageTranslationedValue = (errorResponse: WebApiResponseBase, translateService: TranslateService) => {
  return translateService.instant(GetErrorMessageTranslationId(errorResponse)) as string;
}

export const GetErrorMessageTranslationId = (errorResponse: WebApiResponseBase) => {
  if (!errorResponse || Utilities.isEmptyString(errorResponse.friendlyMessage_Translation_Id)) {
    return "ml_151107";
  }

  return errorResponse.friendlyMessage_Translation_Id;
}

export interface WebApiResponse<T> extends WebApiResponseBase {
  data: T;
}

export interface DataUpdateResponseWithAttachmentUrl {
  putAttachmentS3Url: string;
}

export interface SearchByItem {
  searchBy: string;
  searchByLabel: string;

  searchByType?: smartSearchType;
  searchDropDownValue?: DropDownItem[];
}

export const GetDefaultSearchByItem = () => { return { searchBy: "", searchByLabel: "" } as SearchByItem };

export interface DropDownItem {
  value: any;
  label: string;
}

export const GenerateDropDownItems = (items: string[]) => {
  if (!items) {
    return [];
  }

  return items.map(item => {
    return { value: item, label: item } as DropDownItem;
  })
};
